import 'bootstrap';

export default class Modal {
    init() {
        $(function () {
            $(".modal-backdrop").remove();

            let $modal = $('.modal');
            let $submitButton = $modal.find('[role="button"]');

            $submitButton.click(() => {
                $submitButton.addClass('disabled');
                $submitButton.attr('disabled', 'disabled');
                $('<i class="fas fa-spinner fa-spin"></i>').appendTo($submitButton);
            });

            $modal.modal().on('hidden.bs.modal', (e) => {
                e.preventDefault();

                let $formUnderModal = $('#content').find('form');
                let $formSubmitButton = $formUnderModal.find('button');
                let $spinner = $formUnderModal.find('.fa-spinner');

                $formSubmitButton.removeAttr('disabled');
                $spinner.remove();
            });
        });
    }

    close() {
        $(function () {
            $('.modal').modal('hide');
        });
    }
}
